import React from "react";
import "./WhatsappBtn.css";
import { CONTACTS } from "../constants/contacts";

const WhatsappBtn = () => {
  // Get WhatsApp contact from constants
  const whatsappContact = CONTACTS.find((c) => c.type === "phone");

  if (!whatsappContact) return null;

  const message =
    "Hello 👋 I am visiting your website and would like more information.";

  const whatsappUrl = `${
    whatsappContact.link
  }?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      className="whatsapp-text-btn"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <i className="bi bi-whatsapp"></i>
      <span className="ms-2">How may I help you?</span>
    </a>
  );
};

export default WhatsappBtn;
